export const emptyErrorState = () => ({
    displayName: [],
    description: [],
    // tags: [],
    input: {},
    output: {},
});
